var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import ClaimsButton from '@declaration/components/UI/ClaimsButton.vue';
import BreakInDamageChoices from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageChoices.vue';
import { FLAPPY_SHUTTER_DAMAGE_SEVERITY_TRAD_KEYS_AND_IMAGES, FOLDING_SHUTTER_DAMAGE_SEVERITY_TRAD_KEYS_AND_IMAGES, ROLLING_SHUTTER_DAMAGE_SEVERITY_TRAD_KEYS_AND_IMAGES, } from '@declaration/constants/breakInDamages/ShutterConstants';
import { BreakInDamageShutterType } from '@shared/types/api/breakInDamage';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let ShutterDamageSeverity = class ShutterDamageSeverity extends Vue {
    constructor() {
        super(...arguments);
        this.isSaving = false;
        this.showValidation = false;
        this.flappyDamageSeverityLevels = Object.entries(FLAPPY_SHUTTER_DAMAGE_SEVERITY_TRAD_KEYS_AND_IMAGES).map(([damageSeverity, description]) => ({
            value: damageSeverity,
            tradKey: description.tradKey,
            descriptionTradKey: description.descriptionTradKey,
            image: description.image,
        }));
        this.rollingDamageSeverityLevels = Object.entries(ROLLING_SHUTTER_DAMAGE_SEVERITY_TRAD_KEYS_AND_IMAGES).map(([damageSeverity, description]) => ({
            value: damageSeverity,
            tradKey: description.tradKey,
            descriptionTradKey: description.descriptionTradKey,
            image: description.image,
        }));
        this.foldingDamageSeverityLevels = Object.entries(FOLDING_SHUTTER_DAMAGE_SEVERITY_TRAD_KEYS_AND_IMAGES).map(([damageSeverity, description]) => ({
            value: damageSeverity,
            tradKey: description.tradKey,
            descriptionTradKey: description.descriptionTradKey,
            image: description.image,
        }));
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get damageSeverityLevels() {
        if (this.breakInDamage.shutterType === BreakInDamageShutterType.Flappy) {
            return this.flappyDamageSeverityLevels;
        }
        if (this.breakInDamage.shutterType === BreakInDamageShutterType.Folding) {
            return this.foldingDamageSeverityLevels;
        }
        if (this.breakInDamage.shutterType === BreakInDamageShutterType.Rolling) {
            return this.rollingDamageSeverityLevels;
        }
    }
    get isValid() {
        return !this.validation.fieldHasViolations('damageSeverity');
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.isSaving = true;
        this.$emit('goToNextStep');
        this.isSaving = false;
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
};
__decorate([
    layout.State('color')
], ShutterDamageSeverity.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], ShutterDamageSeverity.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], ShutterDamageSeverity.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], ShutterDamageSeverity.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], ShutterDamageSeverity.prototype, "validateBreakInDamage", void 0);
ShutterDamageSeverity = __decorate([
    Component({
        components: {
            BreakInDamageDescriptionStep,
            BreakInDamageDescriptionSectionCard,
            BreakInDamageChoices,
            ClaimsButton,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
        },
    })
], ShutterDamageSeverity);
export default ShutterDamageSeverity;
